export const CONTACT_EMAIL = 'contact@emmaprologistixs.com';
